import { Injectable, inject } from '@angular/core';

import { Observable, of } from 'rxjs';

import { MiddlewareService } from '@mediahaven/shared';
import { ApiFragment, ApiRecordType, Family, RecordTypesService } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export default class PortalContextMiddleware implements MiddlewareService {
    private recordTypeService: RecordTypesService = inject(RecordTypesService);

    public annotate(record: ApiFragment): Observable<ApiFragment> {
        return of(this.appendAllowedChildrenToContext(record));
    }

    private appendAllowedChildrenToContext(record: ApiFragment): ApiFragment {
        const allowedChildren: ApiRecordType[] = this.recordTypeService.getAllowedChildren(record.getRecordType());

        record.set(Family.Context, 'AllowedChildren', allowedChildren);
        return record;
    }
}
